const mediaQueries = {
    tabletSize: '@media(max-width: 1024px)',
    phoneSize: '@media(max-width: 664px)'
}

export default mediaQueries;